export default __webpack_public_path__ + "static/media/bg.eaa618c9.png";